/* CCC 2026-10-01 – Lesehilfe für Produktbeschreibungen (snippets/ccc27-product-read.liquid).
   Automatisch für alle Produkte: Kapitel werden an den Zwischentiteln (h3) erkannt, in allen 6 Sprachen.
   - «Auf einen Blick» an den Anfang (verschoben, nicht verdoppelt), bis 8 Zeilen als Kacheln
   - Lesezeit und Sprung-Knöpfe nach der Einleitung
   - passende Galerie-Fotos in technischen Kapiteln (nur bei passendem Alt-Text, max. 4)
   - Leiste «Der Papagei liest mit» mit Kauf-Check und Warenkorb-Knopf, der den echten Knopf auslöst
   Gelesen heisst: zusammengerechnet 1–2 Sekunden sichtbar (je nach Kapitellänge) und bis zum Kapitelende
   gescrollt. Der Original-Papagei (snippets/ccc27-parrot) wird nur bewegt, nie verändert.
   CCC 2026-10-16 (Journey-Analyse): Hinweis unter der Leiste nur noch einmal pro Browser (localStorage
   «ccc-pr-hint», 3,5 s statt 4,5 s, verschwindet beim Antippen); Zähler zeigt «0/4 gelesen»;
   «Auf einen Blick» bekommt die Sprungmarke #ccc-auf-einen-blick (Link «Alle Details» aus snippets/ccc27-kernfakten). */
(function () {
  if (window.cccPrInit) return;
  window.cccPrInit = true;

  var DWELL_MS = 2000;
  var TICK_MS = 250;
  var RX = {
    blick: /^(auf einen blick|at a glance|en un coup d|en bref|in sintesi|in breve|a colpo d|de un vistazo|en resumen|num relance|resumo|em resumo)/i,
    wen: /^(für wen|who\b.*\bfor\b|for whom|pour qui|à qui|a qui|per chi|a chi|para quién|para quem)/i,
    contact: /(sprechen|kontakt|beratung|termin|showroom|kaufen|bestellen|anfrage|contact|talk to|buy\b|acheter|parler|acquista|parlare|comprar|hablar|falar)/i,
    faq: /^(häufige fragen|häufig gestellte fragen|frequently asked|faq|questions fréquentes|domande frequenti|preguntas frecuentes|perguntas frequentes)/i,
    passt: /^(was (gut |noch )?dazu passt|das passt( noch)? dazu|passt (\S+ )?dazu|passend|dazu passt|(das|die|der) passende|zubehör,|was dazugehört|das setup,? das dazugehört|was danach passt|was du dazu brauchst)|(\bmatching\b|goes with|go with|pairs (well )?with|what to pair|\bassorti(e|s|es)?\b|va avec|associer|abbinat[oiea]\b|abbina|a juego|combina\b|adequad[oa]s?\b|acompanh)/i,
    toYou: /(zu dir|for you|pour toi|per te|para ti|contigo)\s*\??$/i
  };
  var STOP = {};
  ('und oder der die das den dem des mit für fuer von vom zum zur ein eine einer eines als wie was wer wen ist sind auf aus bei über ueber unter nach vor ohne '
    + 'the and with for from what who which into your about this that are its '
    + 'les des une pour avec dans sur est qui quoi aux par '
    + 'del della delle con per una che sono nel nella '
    + 'los las para con una que por sobre '
    + 'dos das uma com para que sobre pela pelo '
    + 'lieber warum wieso welche welcher welches worauf darum deshalb hier jetzt mehr alles diese dieser dieses unser unsere deine dein wenn damit direkt sprechen kaufen online '
    + 'coffee coaching club espresso espressomaschine espressomaschinen maschine machine kaffee kaffeemaschine').split(' ').forEach(function (w) { STOP[w] = true; });

  function fill(tpl, vars) {
    var s = tpl || '';
    Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function tokens(s) { return (s || '').toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(Boolean); }
  function make(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function byDoc(a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; }

  function init() {
    var host = document.querySelector('[data-ccc-pr]');
    var wrap = document.querySelector('[data-ccc-pr-desc]');
    if (!host || !wrap || wrap.closest('details')) return;
    var cfg;
    try { cfg = JSON.parse(host.querySelector('[data-ccc-pr-cfg]').textContent); } catch (e) { return; }
    wrap.classList.add('ccc27-pr-desc');
    var rte = wrap.querySelector('.element-text, .rte') || wrap;

    var h3s = Array.prototype.slice.call(rte.querySelectorAll('h3')).filter(function (h) {
      return !h.closest('.ccc-roastery-tip, .ccc-cta-block, .ccc-price-ask, table, details, form, aside');
    });
    /* Nur Zwischentitel im Haupttext: der Container mit den meisten h3 (Karten wie «Preis anfragen» zählen nicht) */
    var flow = null, flowN = 0, perParent = [];
    h3s.forEach(function (h) {
      var p = h.parentElement, e = null;
      for (var i = 0; i < perParent.length; i++) { if (perParent[i].p === p) { e = perParent[i]; break; } }
      if (!e) { e = { p: p, n: 0 }; perParent.push(e); }
      e.n++;
      if (e.n > flowN) { flowN = e.n; flow = p; }
    });
    /* Ausnahme: «Häufige Fragen» steckt oft in einem eigenen Block (div.ccc-faq) – zählt trotzdem als Kapitel */
    h3s = h3s.filter(function (h) { return h.parentElement === flow || (flow && flow.contains(h) && RX.faq.test(txt(h))); });
    if (h3s.length < 2) return;
    var chapters = h3s.map(function (h, i) {
      if (!h.id) h.id = 'ccc-k-' + (i + 1);
      return { h: h, label: txt(h) };
    });
    var stages = {};
    /* Kapitel-Titel sind auf allen 2400 Produkten einheitlich (geprüft 2026-10-01), daher strenge Muster am Titelanfang */
    ['blick', 'wen', 'faq', 'passt'].forEach(function (k) {
      for (var i = 0; i < chapters.length; i++) {
        var c = chapters[i];
        if (!c.stage && RX[k].test(c.label) && !(k === 'passt' && RX.toYou.test(c.label))) { c.stage = k; stages[k] = c; break; }
      }
    });
    var anchor = null;
    for (var a = 0; a < chapters.length; a++) { if (chapters[a] !== stages.blick) { anchor = chapters[a].h; break; } }
    if (!anchor) return;

    /* ---------- 1) «Auf einen Blick» an den Anfang ---------- */
    var box = null;
    if (stages.blick) {
      var g = stages.blick;
      var nodes = [];
      var n = g.h.nextElementSibling;
      while (n && !/^H[1-3]$/.test(n.tagName)) { nodes.push(n); n = n.nextElementSibling; }
      box = make('section', 'ccc27-pr-glance');
      if (!document.getElementById('ccc-auf-einen-blick')) box.id = 'ccc-auf-einen-blick';
      box.setAttribute('aria-labelledby', g.h.id);
      box.appendChild(g.h);
      var table = null;
      nodes.forEach(function (x) { if (!table) table = x.tagName === 'TABLE' ? x : (x.querySelector && x.querySelector('table')); });
      var rows = [];
      if (table) {
        Array.prototype.forEach.call(table.rows, function (r) {
          var cells = Array.prototype.map.call(r.cells, txt);
          if (cells.length === 2 && cells[0] && cells[1]) rows.push(cells);
        });
      }
      var asTiles = rows.length >= 2 && rows.length <= 8 && rows.every(function (r) { return r[1].length <= 60; });
      if (asTiles) {
        var ul = make('ul', 'ccc27-pr-tiles');
        ul.setAttribute('role', 'list');
        rows.forEach(function (r) {
          var li = make('li', 'ccc27-pr-tile');
          li.appendChild(make('span', 'ccc27-pr-tile__k', r[0]));
          li.appendChild(make('span', 'ccc27-pr-tile__v', r[1]));
          ul.appendChild(li);
        });
        box.appendChild(ul);
        nodes.forEach(function (x) {
          if (x === table || (x.contains && x.contains(table))) x.parentNode.removeChild(x);
          else box.appendChild(x);
        });
      } else {
        nodes.forEach(function (x) { box.appendChild(x); });
        box.classList.add('ccc27-pr-glance--table');
      }
      anchor.parentNode.insertBefore(box, anchor);
    }

    /* ---------- 2) Lesezeit und Sprung-Knöpfe ---------- */
    var meta = make('div', 'ccc27-pr-meta');
    meta.appendChild(make('span', 'ccc27-pr-pill ccc27-pr-pill--time', fill(cfg.time, { n: cfg.minutes })));
    ['blick', 'wen', 'passt', 'faq'].forEach(function (k) {
      var c = stages[k];
      if (!c) return;
      var l = make('a', 'ccc27-pr-pill', cfg.words[k]);
      l.href = '#' + c.h.id;
      meta.appendChild(l);
      c.chip = l;
    });
    (box || anchor).parentNode.insertBefore(meta, box || anchor);

    /* ---------- 3) Galerie-Fotos in technischen Kapiteln ---------- */
    var media = (cfg.media || []).filter(function (m) { return m && m.src && m.alt; });
    var titleTok = {};
    tokens(cfg.title + ' ' + cfg.vendor).forEach(function (t) { titleTok[t] = true; });
    function core(alt) {
      return tokens(alt.replace(/\s*[-–]\s*coffee coaching club.*$/i, '')).filter(function (t) { return !titleTok[t] && !STOP[t] && !/^\d+$/.test(t); }).join(' ');
    }
    var usedCore = {};
    if (media.length) usedCore[core(media[0].alt)] = true;
    var placed = 0;
    var isDe = /^de/i.test(document.documentElement.lang || 'de');
    chapters.forEach(function (c) {
      if (placed >= 4 || c.stage || RX.contact.test(c.label)) return;
      /* Deutsch: nur Nomen (gross geschrieben) und Begriffe mit Ziffern, damit «direkt» o. Ä. kein Foto auslöst */
      var raw = (c.label || '').split(/[^\p{L}\p{N}]+/u).filter(Boolean);
      var toks = raw.filter(function (w) { return !isDe || /\d/.test(w) || /^\p{Lu}/u.test(w); })
        .map(function (w) { return w.toLowerCase(); })
        .filter(function (t) { return (t.length >= 4 || (t.length >= 3 && /\d/.test(t))) && !STOP[t] && !titleTok[t]; });
      if (!toks.length) return;
      var best = -1, bestScore = 0;
      media.forEach(function (m, i) {
        if (i === 0) return;
        var cc = core(m.alt);
        if (!cc || usedCore[cc]) return;
        var alt = m.alt.toLowerCase();
        var score = 0;
        toks.forEach(function (t) { if (alt.indexOf(t) >= 0) score++; });
        if (score > bestScore) { bestScore = score; best = i; }
      });
      if (best < 0) return;
      var m = media[best];
      usedCore[core(m.alt)] = true;
      var cap = m.alt.replace(/\s*[-–]\s*coffee coaching club.*$/i, '').trim();
      if (cfg.title && cap.toLowerCase().indexOf(cfg.title.toLowerCase()) === 0) cap = cap.slice(cfg.title.length).trim();
      cap = cap.replace(/^[-–:,\s]+/, '');
      var fig = make('figure', 'ccc27-pr-fig');
      var img = document.createElement('img');
      img.src = m.src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      if (m.w && m.h) { img.width = m.w; img.height = m.h; }
      fig.appendChild(img);
      /* Andere Sprachen: deutsche Bildtexte (nicht übersetzt) nicht anzeigen, das Foto bleibt */
      if (!isDe && /(\b(und|mit|der|die|im|von|beim)\b|[äöüß]|ansicht|edelstahl|schwarz|weiss|poliert)/i.test(cap)) cap = '';
      if (cap.length > 2) fig.appendChild(make('figcaption', 'ccc27-pr-fig__cap', cap.charAt(0).toUpperCase() + cap.slice(1)));
      var p = c.h.nextElementSibling;
      while (p && p.tagName !== 'P' && !/^H[1-4]$/.test(p.tagName)) p = p.nextElementSibling;
      var after = p && p.tagName === 'P' ? p : c.h;
      after.parentNode.insertBefore(fig, after.nextSibling);
      placed++;
    });

    /* ---------- 4) Leiste: Papagei liest mit, Kauf-Check, Warenkorb ---------- */
    var dims = ['blick', 'wen', 'passt', 'faq'].filter(function (k) { return stages[k]; }).map(function (k) {
      return { k: k, c: stages[k], ms: 0, end: false, found: false };
    });
    if (dims.length < 2) return;
    chapters.sort(function (x, y) { return byDoc(x.h, y.h); });
    var heads = chapters.map(function (c) { return c.h; });
    /* Kapitelende: nächster Zwischentitel oder ein eigener Block (FAQ, Kontakt, Preis-Karte), sonst Ende des Containers */
    function isHead(x) { for (var k = 0; k < heads.length; k++) { if (x === heads[k] || x.contains(heads[k])) return true; } return false; }
    dims.forEach(function (d) {
      if (d.k === 'blick' && box) { d.box = box; return; }
      var x = d.c.h.nextElementSibling;
      while (x) {
        if (isHead(x) || /^H[12]$/.test(x.tagName) || (d.k !== 'faq' && (x.matches('.ccc-faq, .ccc-cta-block, .ccc-price-ask') ||
            (!x.matches('.ccc-roastery-tip') && x.querySelector('h2, h3, h4'))))) { d.endEl = x; return; }
        x = x.nextElementSibling;
      }
      d.endBox = d.c.h.parentElement;
    });

    var mainBtn = document.querySelector('.product-single__meta form[data-type="add-to-cart-form"] button[name="add"]') || document.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
    var priceEl = document.querySelector('.product-single__meta .product__price, .product-single__meta [data-product-price]');
    var parrotTpl = host.querySelector('template[data-ccc-pr-parrot]');

    var bar = make('div', 'ccc27-pr-bar');
    var inn = make('div', 'ccc27-pr-bar__in');
    var now = make('p', 'ccc27-pr-bar__now');
    var cnt = make('span', 'ccc27-pr-bar__cnt');
    cnt.setAttribute('role', 'img');
    var price = make('span', 'ccc27-pr-bar__price');
    var buy = make('button', 'ccc27-pr-bar__buy');
    buy.type = 'button';
    var fin = make('div', 'ccc27-pr-fin');
    var finT = make('p', 'ccc27-pr-fin__t', cfg.fin);
    var finL = make('button', 'ccc27-pr-fin__l', cfg.finLink + ' ›');
    finL.type = 'button';
    finL.setAttribute('data-ccc-jackson', cfg.question);
    fin.appendChild(finT);
    fin.appendChild(finL);
    var toastEl = make('p', 'ccc27-pr-bar__toast');
    toastEl.setAttribute('aria-hidden', 'true');
    toastEl.addEventListener('click', function () { toastEl.classList.remove('is-show'); });
    var live = make('span', 'visually-hidden');
    live.setAttribute('aria-live', 'polite');
    inn.appendChild(now);
    inn.appendChild(fin);
    inn.appendChild(cnt);
    inn.appendChild(price);
    if (mainBtn) inn.appendChild(buy);
    inn.appendChild(toastEl);
    inn.appendChild(live);
    var track = make('div', 'ccc27-pr-bar__track');
    var trackFill = make('span');
    track.setAttribute('aria-hidden', 'true');
    track.appendChild(trackFill);
    bar.appendChild(inn);
    bar.appendChild(track);
    /* CCC 2026-10-02: Die Leiste hängt jetzt direkt an der Kopfzeile (Kind von .header-section, CSS top: 100 %)
       und bewegt sich mit ihr, ohne JavaScript. Vorher wurde sie bei jedem Scroll-Ereignis per JS unter die
       Kopfzeile geschoben; auf dem iPhone hinkte das dem Scrollen hinterher (Lücke über der Leiste, Leiste
       unter der Kopfzeile, Zucken beim schnellen Hin- und Herscrollen). Ist die Kopfzeile weggescrollt
       (nicht sticky), sitzt die Leiste fix am oberen Rand (Klasse is-free). */
    function dock() {
      var h = document.querySelector('.header-section') || document.querySelector('[id$="__header"]');
      var target = h || document.body;
      if (bar.parentNode !== target) target.appendChild(bar);
      bar.classList.toggle('is-docked', !!h);
      return h;
    }
    var header = dock();

    function syncBuy() {
      if (!mainBtn) return;
      var t = txt(mainBtn);
      if (t && cfg.add && cfg.addShort && t.toLowerCase() === String(cfg.add).trim().toLowerCase()) t = cfg.addShort;
      buy.textContent = t || buy.textContent;
      buy.setAttribute('aria-label', txt(mainBtn) || t);
      buy.disabled = !!mainBtn.disabled;
    }
    function syncPrice() {
      if (!priceEl) { price.hidden = true; return; }
      var t = txt(priceEl);
      var m = t.match(/(CHF|Fr\.|€|EUR)\s?[\d'’.,  ]+/);
      price.textContent = m ? m[0].trim() : '';
    }
    if (mainBtn) {
      syncBuy();
      new MutationObserver(syncBuy).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      buy.addEventListener('click', function () { if (!mainBtn.disabled) mainBtn.click(); });
    }
    syncPrice();
    if (priceEl) new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true });

    var wordEl = null, parrotEl = null;
    /* CCC 2026-10-02: in einem Schritt statt Schleife (weniger Layout-Arbeit beim schnellen Scrollen) */
    function fit() {
      if (!wordEl) return;
      wordEl.style.fontSize = '';
      var max = now.clientWidth;
      if (!max) return;
      var w = wordEl.getBoundingClientRect().width;
      if (w <= max) return;
      var size = parseFloat(window.getComputedStyle(wordEl).fontSize) || 28;
      wordEl.style.fontSize = Math.max(16, Math.floor(size * max / w)) + 'px';
    }
    function setWord(w, srText) {
      var chars = Array.from(String(w || '').trim());
      if (!chars.length) return;
      now.textContent = '';
      var sr = make('span', 'visually-hidden', srText || w);
      wordEl = make('span', 'ccc27-pr-word');
      wordEl.setAttribute('aria-hidden', 'true');
      wordEl.appendChild(document.createTextNode(chars.slice(0, -1).join('')));
      var pl = make('span', 'ccc27-pr-pl', chars.slice(-1).join(''));
      if (parrotTpl) {
        parrotEl = parrotTpl.content.firstElementChild.cloneNode(true);
        pl.appendChild(parrotEl);
      }
      wordEl.appendChild(pl);
      now.appendChild(sr);
      now.appendChild(wordEl);
      fit();
    }
    var foundCount = 0;
    function renderCount() {
      cnt.textContent = foundCount + '/' + dims.length;
      if (cfg.read) cnt.appendChild(make('span', 'ccc27-pr-bar__cntl', ' ' + cfg.read));
      cnt.setAttribute('aria-label', fill(cfg.aria, { n: foundCount, total: dims.length }));
      cnt.classList.toggle('is-done', foundCount === dims.length);
    }
    renderCount();

    var toastTimer = null;
    function toast(text, ms) {
      toastEl.textContent = text;
      toastEl.classList.add('is-show');
      live.textContent = text;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, ms);
    }
    function hop() {
      if (parrotEl) {
        parrotEl.classList.remove('is-hop');
        void parrotEl.getBoundingClientRect();
        parrotEl.classList.add('is-hop');
        var el = parrotEl;
        setTimeout(function () { el.classList.remove('is-hop'); }, 800);
      }
      cnt.classList.remove('is-pop');
      void cnt.getBoundingClientRect();
      cnt.classList.add('is-pop');
      setTimeout(function () { cnt.classList.remove('is-pop'); }, 600);
    }
    /* CCC 2026-10-01 (Wunsch Yalcin): Ab «Alles gelesen» bleibt die Leiste pink mit Jackson und Warenkorb,
       auch beim Zurückscrollen und beim nächsten Besuch dieses Produkts (gemerkt 30 Tage, nur in diesem Browser). */
    var allRead = false;
    function finale() {
      allRead = true;
      toastEl.classList.remove('is-show');
      bar.classList.add('is-finale');
    }
    var STORE = 'ccc-pr-read:' + location.pathname.replace(/^\/(en|fr|it|es|pt)(?=\/)/, '');
    function save() {
      try {
        localStorage.setItem(STORE, JSON.stringify({ t: Date.now(), k: dims.filter(function (d) { return d.found; }).map(function (d) { return d.k; }) }));
      } catch (e) {}
    }
    try {
      var saved = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (saved && saved.k && Date.now() - saved.t < 30 * 864e5) {
        dims.forEach(function (d) {
          if (saved.k.indexOf(d.k) >= 0 && !d.found) {
            d.found = true;
            foundCount++;
            if (d.c.chip) d.c.chip.classList.add('is-found');
          }
        });
        renderCount();
        if (foundCount === dims.length) finale();
      }
    } catch (e) {}

    function bounds(d) {
      if (d.box) return d.box.getBoundingClientRect();
      var t = d.c.h.getBoundingClientRect();
      var b = d.endEl ? d.endEl.getBoundingClientRect().top : (d.endBox || rte).getBoundingClientRect().bottom;
      return { top: t.top, bottom: b };
    }
    function tick() {
      if (foundCount === dims.length || document.hidden) return;
      var vh = window.innerHeight;
      /* CCC 2026-10-01: Sichtbar heisst zwischen Leiste und unterem Rand. Kurze Kapitel brauchen weniger
         Zeit (1 s unter 500 px, 1,5 s unter 1000 px, sonst 2 s), damit auch zügiges Lesen zählt.
         Wer nur durchrast oder springt, sammelt weiterhin nichts. */
      var barBottom = bar.classList.contains('is-on') ? bar.getBoundingClientRect().bottom : 0;
      /* Am Textende angekommen: Kapitel, die mindestens kurz (0,5 s) sichtbar waren, zählen auch. */
      var atEnd = rte.getBoundingClientRect().bottom < vh * 0.85;
      var fresh = [];
      dims.forEach(function (d) {
        if (d.found) return;
        var r = bounds(d);
        var h = r.bottom - r.top;
        var need = h < 500 ? 1000 : (h < 1000 ? 1500 : DWELL_MS);
        if (r.top < vh * 0.85 && r.bottom > barBottom + 40) d.ms += TICK_MS;
        if (r.bottom < vh * 0.85) d.end = true;
        if (d.end && (d.ms >= need || (atEnd && d.ms >= 500))) fresh.push(d);
      });
      if (!fresh.length) return;
      fresh.forEach(function (d) {
        d.found = true;
        foundCount++;
        if (d.c.chip) d.c.chip.classList.add('is-found');
      });
      renderCount();
      save();
      hop();
      if (foundCount === dims.length) {
        live.textContent = cfg.fin;
        finale();
      } else {
        live.textContent = fill(cfg.found, { name: cfg.words[fresh[0].k] }) + ' · ' + foundCount + '/' + dims.length;
      }
    }
    setInterval(tick, TICK_MS);

    var current = -2, hintShown = false, ticking = false, free = null;
    function update() {
      ticking = false;
      if (!bar.isConnected || (header && !header.isConnected)) header = dock();
      /* Nur lesen, nie Pixel setzen: Kopfzeile sichtbar = Leiste hängt daran, sonst fix oben */
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var isFree = !(hb > 0.5);
      if (isFree !== free) { free = isFree; bar.classList.toggle('is-free', isFree); }
      var top = isFree ? 0 : Math.round(hb);
      var was = bar.classList.contains('is-on');
      /* CCC 2026-10-01 (Wunsch Yalcin): Leiste bleibt bis ganz unten, sobald der Kaufknopf weggescrollt ist,
         damit «In den Warenkorb» immer erreichbar ist. Vorher: nur solange die Beschreibung sichtbar war.
         CCC 2026-10-02: 40 px Spielraum beim Ausblenden, damit sie an der Schwelle nicht flackert. */
      var passedBuy = mainBtn ? (mainBtn.offsetParent === null || mainBtn.getBoundingClientRect().bottom < top + (was ? 40 : 0)) : (wrap.getBoundingClientRect().top < window.innerHeight - 80);
      var on = passedBuy;
      bar.classList.toggle('is-on', on);
      if (!on) { toastEl.classList.remove('is-show'); return; }
      if (!was) { syncBuy(); fit(); }
      if (!hintShown) {
        hintShown = true;
        var seen = '1';
        try { seen = localStorage.getItem('ccc-pr-hint'); } catch (e) {}
        if (foundCount === 0 && !seen) {
          try { localStorage.setItem('ccc-pr-hint', '1'); } catch (e) {}
          toast(fill(cfg.hint, { total: dims.length }), 3500);
        }
      }
      var w = wrap.getBoundingClientRect();
      var span = w.height - (window.innerHeight - top);
      var done = span > 0 ? Math.min(1, Math.max(0, (top - w.top) / span)) : 1;
      trackFill.style.transform = 'scaleX(' + done.toFixed(3) + ')';
      var idx = -1;
      for (var i = 0; i < chapters.length; i++) {
        if (chapters[i].h.getBoundingClientRect().top <= top + 110) idx = i;
        else break;
      }
      if (idx !== current) {
        current = idx;
        var c = idx >= 0 ? chapters[idx] : null;
        var word = c ? (c.stage ? cfg.words[c.stage] : cfg.words.details) : cfg.words.intro;
        setWord(word, c ? c.label : word);
      }
    }
    function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { schedule(); fit(); });
    setWord(cfg.words.intro, cfg.words.intro);
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
